module.exports = __webpack_public_path__ + "00285c91ff08c96597e73292a9e9f696.svg";